import React, { useState, useCallback } from 'react';
import ButtonGroup from 'components/ButtonGroup';

import { Content, ContentButton, Container } from './styles';

import ListaExclusao from './listaexclusao';
import Validos from './validos';

export default function Exclusao() {
  const [viewValidos, setViewValidos] = useState(false);

  const handleView = useCallback(validos => {
    setViewValidos(validos);
  }, []);

  return (
    <Container>
      <Content>
        <header>
          <div />
          <ContentButton>
            <ButtonGroup $activeButton={viewValidos}>
              <button onClick={() => handleView(false)}>Lista</button>
              <button onClick={() => handleView(true)}>Validos</button>
            </ButtonGroup>
          </ContentButton>
        </header>
        {viewValidos ? <Validos /> : <ListaExclusao />}
      </Content>
    </Container>
  );
}
